export default __webpack_public_path__ + "images/assets/9720c37abeceab3f79cffb037f69329e.svg";